<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">供应商名称</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Name"
                        remote
                        filterable
                        allow-create
                        placeholder="请输入供应商名称"
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                    </el-select>
                    <div class="search-name">标签</div>
                    <el-select class="search-item" size="small" filterable clearable v-model="searchData.Tag" @visible-change="supTagVisibleChange($event)">
                        <el-option v-for="optionItem in supTagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                    </el-select>
                    <div class="search-name">地区</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.Zone" placeholder="地区"></el-input>
                    <div class="search-name">采购员</div>
                    <el-select v-model="searchData.SId" size="small" class="search-item" filterable placeholder="请选择" @visible-change="supSiVisibleChange($event)">
                        <el-option v-for="item in supSIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">时间区间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        size="small"
                        class="search-item"
                        type="daterange"
                        align="right"
                        style="width: 235px"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="onDateTimeSelect"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                            <i class="fa fa-file-excel-o"></i>
                            {{ permission.export }}</el-button
                        >
                    </div>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="sdata-count">
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">采购总计 = 采购总额 + 总运费</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >采购总计
                            </p>
                            <p>￥{{ purStatData.orderAllTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购总额</p>
                            <p>￥{{ purStatData.orderTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购单总数</p>
                            <p>{{ purStatData.orderCount }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购商品总数</p>
                            <p>{{ purStatData.goodsTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>运费总计</p>
                            <p>{{ purStatData.transTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购退货总额</p>
                            <p>￥{{ purStatData.returnTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">实际采购额 = 采购总额 - 采购退货总额</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >实际采购额
                            </p>
                            <p>￥{{ purStatData.acAmount }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>退货总数</p>
                            <p>{{ purStatData.returnGoodsTotal }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableSupplierData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'TotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="150px" prop="Name" label="供应商名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Zone" label="地区"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="120" prop="TotalAmount" label="采购单总额"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="110" prop="TotalShipAmount" label="采购总运费"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="120" prop="OrderCount" label="采购单总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="110" prop="GoodsCount" label="商品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="110" prop="GoodsCateCount" label="商品种类"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="130" prop="ReturnTotalAmount" label="采购退货总额"></el-table-column>
                    <el-table-column min-width="140" label="采购退货数(件)" show-overflow-tooltip sortable="custom">
                        <template slot-scope="scope">
                            {{ scope.row.ReturnGoodsCount }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" min-width="130" prop="ReturnAmount" label="实际采购额">
                        <template slot-scope="scope">
                            {{ (scope.row.TotalAmount - scope.row.ReturnTotalAmount).toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120" label="最新采购员" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.Follower }}
                        </template>
                    </el-table-column>
                    <el-table-column label="其他统计" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="采购数据" size="mini" type="text" @click="showPurchaseStat(scope.row)">采购数据</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" :title="PurchaseDialogTitle" :visible.sync="showPurchaseStatDialog" :append-to-body="true" width="1300px">
                <div v-if="showPurchaseStatDialog">
                    <purchaseStat
                        @closeDialog="closePurchaseStatDialog"
                        :EntpCusId="this.entpCusId"
                        :StartDate="this.searchData.StartDate"
                        :EndDate="this.searchData.EndDate"
                    ></purchaseStat>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import purchaseStat from '@/components/business/revenue/cusPurchaseStat';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        purchaseStat
    },
    data() {
        return {
            dateTimes: [],
            permission: {},
            showPurchaseStatDialog: false,
            PurchaseDialogTitle: '',
            entpCusId: '',
            supTagsList: [],
            supSIdList: [],
            searchData: {
                Name: '',
                Tag: '',
                Zone: '',
                SId: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            purStatData: {
                orderTotal: 0,
                orderCount: 0,
                goodsTotal: 0,
                transTotal: 0,
                returnTotal: 0,
                returnGoodsTotal: 0,
                orderAllTotal: 0,
                acAmount: 0
            },
            tableDataLength: 0,
            tableSupplierData: [],
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            exportTotalCount: 0
        };
    },
    filters: {
        profitPercentage(val1, val2) {
            if (val1 && val2) {
                return Number((val1 / val2) * 100).toFixed(2) * 1 + '%';
            } else {
                return '0%';
            }
        }
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('SupStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        //this.searchSupplier();
    },
    methods: {
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Name: '',
                Tag: '',
                Zone: '',
                SId: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            // this.searchSupplier('');
            this.dateTimes = [];
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/SupplierStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        this.tableSupplierData = data.DataList;

                        if (this.searchData.page == 1) {
                            this.purStatData = {
                                orderTotal: data.OrderTotal,
                                orderCount: data.OrderCount,
                                goodsTotal: data.GoodsTotal,
                                transTotal: data.TransTotal,
                                returnTotal: data.ReturnTotal,
                                returnGoodsTotal: data.ReturnGoodsTotal,
                                orderAllTotal: data.OrderAllTotal,
                                acAmount:(data.OrderTotal - data.ReturnTotal).toFixed(2)
                            };
                            this.tableDataLength = res.count;
                        }
                    }
                })
                .catch(() => {});
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        searchSupTags() {
            let url = '/api/EntpSuppliers/GetEnterpriseSupplierTagList';
            this.loading = true;
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.supTagsList = res.data;
                });
        },
        supTagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.supTagsList.length == 0) that.searchSupTags();
            }
        },
        getSupSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.supSIdList = data;
            });
        },
        //当业务员下拉框出现时触发
        supSiVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSupSIdList();
            }
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showPurchaseStat(row) {
            if (row) {
                this.PurchaseDialogTitle = '【 ' + row.Name + ' 】采购数据';
                this.entpCusId = row.EntpCusId;
                this.showPurchaseStatDialog = true;
            }
        },
        closePurchaseStatDialog() {
            this.showPurchaseStatDialog = false;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        exportData() {
            let that = this;
            if (that.tableSupplierData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            // let saveLimit = 100;
            // if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;
            let saveLimit = that.tableDataLength;
            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetSupStatisticsToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    let data = resp.data;
                    if (that.currtPage == 1) that.exportTotalCount = data.totalCount;
                    // that.saveCount += saveLimit;
                    that.saveCount += data.count;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.exportTotalCount);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.exportTotalCount <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/DataStatistics/ExportSupStatistics'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.exportTotalCount = 0;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.exportTotalCount = 0;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.sdata-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 14.2%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>